import request from "@/utils/request";

/**
 * 数据分析 - 根据区域获取供应或需求详情
 * @param {String} type - 统计类型 project：供应，demand：需求
 * @param {String} data_type - 数据类型 area：面积汇总，count：数量
 * @param {String} district - 行政区域编码
 * @param {String} use_type - 土地用途
 * @param {String} start_time - 开始时间 YYYY-MM-DD
 * @param {String} end_time - 结束时间 YYYY-MM-DD
 * @returns Promise
 */
export const reportDetail = ({
  type,
  data_type,
  district,
  use_type,
  start_time,
  end_time,
}) => {
  return request("/report/detail", "post", {
    type,
    data_type,
    district,
    use_type,
    start_time,
    end_time,
  });
};

/**
 * 数据分析 - 供需比对图表
 * @param {String} data_type - 数据类型  area：面积汇总，count：数量
 * @param {String} use_type - 土地用途
 * @param {String} start_time - 开始时间 YYYY-MM-DD
 * @param {String} end_time - 结束时间 YYYY-MM-DD
 * @returns Promise
 */
export const reportGraph = ({ data_type, use_type, start_time, end_time }) => {
  return request("/report/graph", "post", {
    data_type,
    use_type,
    start_time,
    end_time,
  });
};
